import React, { useEffect } from 'react';
import { CertificatesCatalogWrapper } from '@components';
import { scrollTop } from '@share/utils';
import styles from './styles.module.scss';

export const CertificateCatalogPage = (): React.ReactElement => {
  useEffect(() => {
    scrollTop();
  }, []);

  return (
    <div className={styles.root}>
      <CertificatesCatalogWrapper />
    </div>
  );
};
